import {
  SelectAllWrapper,
  StyledCheckbox,
  SelectAllLabel,
} from './SourceSiteSelectionControl.styles'
import { FormControlLabel } from 'Features/Project/WorkcentreModal/FormControlLabel/FormControlLabel.view'
import {
  isAllSourceSitesSelected,
  isSomeSourceSitesSelected,
  isAllProductCountsInSourcesitesZero,
} from 'Features/Project/WorkcentreModal/WorkcentreModal.utils'

export const SourceSiteSelectionControl = ({
  sourceSiteDetails,
  handleCheckboxChange,
}: any) => {
  return (
    <SelectAllWrapper>
      <FormControlLabel
        label={<SelectAllLabel>Select all source sites</SelectAllLabel>}
        control={
          <StyledCheckbox
            // disabled={isAllProductCountsInSourcesitesZero(sourceSiteDetails)}
            indeterminate={isSomeSourceSitesSelected(sourceSiteDetails)}
            checked={isAllSourceSitesSelected(sourceSiteDetails)}
            onChange={(event) => handleCheckboxChange(event)}
          />
        }
      />
    </SelectAllWrapper>
  )
}
